import {
    GET_USERPROVISIONING_DATA,
    GET_USERPROVISIONING_DATA_SUCCESS,
    TOGGLE_USERPROVISIONING,
    TOGGLE_USERPROVISIONING_SUCCESS,
    REGENERATE_API_TOKEN,
    REGENERATE_API_TOKEN_SUCCESS,
} from './actionTypes';

const initialState = {
    isLoading: true,
    enabled: false,
    baseUrl: '',
    apiToken: '',
};

export const userProvisioningReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERPROVISIONING_DATA:
        case TOGGLE_USERPROVISIONING:
        case REGENERATE_API_TOKEN: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case GET_USERPROVISIONING_DATA_SUCCESS:
        case TOGGLE_USERPROVISIONING_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                enabled: action?.payload?.enabled,
                baseUrl: action?.payload?.base_url ?? '',
                apiToken: action?.payload?.api_token ?? '',
            };
        }

        case REGENERATE_API_TOKEN_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                apiToken: action?.payload?.api_token ?? '',
            };
        }

        default:
            return state;
    }
};
